// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"To-z","imageAndVideoCount":"Uo-z","imageAndVideoContainer":"Vo-z","viewAllReviews":"Wo-z"};